
export const ArrowForward = () => {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.01318 9.61865H17.145" stroke="white" stroke-width="2.26977" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.8488 4.32251L17.1449 9.61862L11.8488 14.9147" stroke="white" stroke-width="2.26977" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}
